import React from 'react';
import {
    Container,
    Typography,
    Box,
    Grid,
    Card,
    CardMedia,
    CardContent,
    Divider,
    Paper
} from '@mui/material';
import './About.scss';

const About: React.FC = () => {
    const values = [
        {
            title: 'User-Focused Design',
            description: 'We design our apps with users in mind, prioritizing intuitive interfaces and seamless experiences. Every feature is crafted to solve real problems and enhance daily life.'
        },
        {
            title: 'Innovation & Quality',
            description: 'We\'re constantly pushing boundaries with innovative features while maintaining the highest standards of quality. Our apps are thoroughly tested to ensure reliability.'
        },
        {
            title: 'Privacy & Trust',
            description: 'We respect our users\' privacy and are transparent about data practices. We build trust through clear communication and honest business practices.'
        }
    ];

    const teamMembers = [
        {
            name: 'Alex Johnson',
            role: 'Founder & CEO',
            bio: 'Alex has over 10 years of experience in app development and entrepreneurship. He founded Planet B with a vision to create useful apps that enhance everyday life.',
            image: '/images/team-member1.svg'
        },
        {
            name: 'Sarah Chen',
            role: 'Lead Developer',
            bio: 'Sarah is an expert in iOS and Android development with a passion for creating smooth, intuitive user experiences.',
            image: '/images/team-member2.svg'
        },
        {
            name: 'Michael Rodriguez',
            role: 'Design Director',
            bio: 'Michael brings creativity and design thinking to all our products, ensuring they are not only functional but also beautiful.',
            image: '/images/team-member3.svg'
        }
    ];

    return (
        <div className="about-page">
            <Box className="hero-section">
                <Container maxWidth="lg">
                    <Typography variant="h3" component="h1" gutterBottom>
                        About Planet B
                    </Typography>
                    <Typography variant="h6">
                        Empowering innovation through stellar apps
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="lg" sx={{ my: 6 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h4" component="h2" gutterBottom>
                            Our Story
                        </Typography>
                        <Typography paragraph>
                            Planet B was founded with a vision to create stellar experiences through innovative applications.
                            We believe in pushing the boundaries of what's possible and creating digital solutions that make
                            life better for people around the world.
                        </Typography>
                        <Typography paragraph>
                            Since our inception, we've grown from a small team of passionate developers to a diverse community
                            of creators, designers, and problem solvers. Our journey has been defined by continuous learning,
                            adaptation, and a commitment to excellence.
                        </Typography>
                        <Typography paragraph>
                            Today, we continue to explore new frontiers in technology, always with the goal of creating
                            meaningful experiences that connect, inform, and inspire.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box className="about-image-container">
                            <img
                                src="/images/about-hero.svg"
                                alt="Planet B team"
                                className="about-image"
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Box sx={{ bgcolor: 'background.paper', py: 6 }}>
                <Container maxWidth="lg">
                    <Typography variant="h4" component="h2" gutterBottom align="center">
                        Our Values
                    </Typography>
                    <Divider sx={{ mb: 4 }} />

                    <Grid container spacing={3}>
                        {values.map((value) => (
                            <Grid item xs={12} sm={6} md={4} key={value.title}>
                                <Card className="value-card">
                                    <CardContent>
                                        <Typography variant="h5" component="h3" gutterBottom>
                                            {value.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {value.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* <Container maxWidth="lg" sx={{ my: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom align="center">
                    Meet Our Team
                </Typography>
                <Divider sx={{ mb: 4 }} />

                <Grid container spacing={4}>
                    {teamMembers.map((member) => (
                        <Grid item xs={12} sm={6} md={4} key={member.name}>
                            <Card className="team-member-card">
                                <CardMedia
                                    component="img"
                                    className="team-member-image"
                                    image={member.image}
                                    alt={member.name}
                                />
                                <CardContent>
                                    <Typography variant="h6" component="h3">
                                        {member.name}
                                    </Typography>
                                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                                        {member.role}
                                    </Typography>
                                    <Typography variant="body2">
                                        {member.bio}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container> */}
        </div>
    );
};

export default About; 